import { render, staticRenderFns } from "./Aperitivore.vue?vue&type=template&id=6f22f070&scoped=true&"
import script from "./Aperitivore.vue?vue&type=script&lang=js&"
export * from "./Aperitivore.vue?vue&type=script&lang=js&"
import style0 from "./Aperitivore.vue?vue&type=style&index=0&id=6f22f070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f22f070",
  null
  
)

export default component.exports